<template>
  <div
    class="installation-pending"
    :class="[
      status === 'success' ? 'installation-pending--success' : '',
      status === 'error' ? 'installation-pending--error' : '',
    ]"
  >
    <div class="installation-pending__content">
      <!-- <div class="installation-pending__background">
        <svg width="74" height="71" viewBox="0 0 74 71" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3.31077 47.1185C-7.38322 36.9575 9.25187 4.72746 32.8335 0.658479C59.3171 -3.91625 77.8945 16.0379 73.3015 39.0495C68.2287 64.4289 34.9357 77.1186 25.4299 68.1071C19.8545 62.8197 29.1546 56.3139 22.2994 49.8081C15.4443 43.3024 8.315 51.8771 3.33362 47.1185H3.31077Z" fill="var(--v-illustrations-lighten2)"/>
        </svg>

      </div> -->
      <!-- <InstanceItemImporting v-if="status === 'error' && imported" class="installation-pending__img installation-pending__img--error"/>
      <InstanceItemInstallationIllustrationError
        v-else-if="status === 'error'"
        class="installation-pending__img installation-pending__img--error"
      >
      </InstanceItemInstallationIllustrationError> -->
      <!-- <InstanceItemImporting v-else-if="status === 'success' && imported" class="installation-pending__img installation-pending__img--pending"/>
      <InstanceItemImporting v-else-if="imported" class="installation-pending__img installation-pending__img--pending pending-animation"/> -->
      <!-- <InstanceItemInstallationIllustrationPending
        
        class="installation-pending__img installation-pending__img--pending"
      >
        <v-icon v-if="status === 'success'" color="#fff" size="24"
          >$check</v-icon
        >
        <loader v-else :noMargins="true" :color="'#fff'" :size="12" />
      </InstanceItemInstallationIllustrationPending> -->

      <div class="installation-pending__text p-4">
        <template v-if="status === 'error' && imported">
          <div class="d-flex align-center justify-center flex-column gray--text text--darken-2">
            <v-icon color="gray darken-1" style="height: 22px; width: 22px;" class="import-pending__step-icon">$download</v-icon>
            <div class="import-pending__step-info gray--text text--darken-1 mt-3 px-2">
              {{ $t('message.status.importing.inProgress') }}
            </div>
          </div>
          <v-progress-linear
            :value="(stepPercent === null || !isImport) ? 0 : stepPercent"
            :indeterminate="stepPercent === null || !isImport"
            color="primary"
            class="import-pending__progress mb-1 mt-4"
            rounded
          />
          <div v-if="stepPercent && isImport" class="d-flex align-center justify-space-between w-100">
            <span class="gray--text text--darken-1 p-xxs">{{ $t('Migrating Files') }}</span>
            <span class="gray--text text--darken-1 p-xxs">{{ stepPercent }}%</span>
          </div>
        </template>
        <template v-else-if="status === 'error'">
          <!-- {{ $t('message.status.install.failed') }} <a class="error--text">{{ $t('button.try') }}</a> -->
          <div class="d-flex align-center justify-center flex-column gray--text text--darken-2">
            <v-icon color="gray darken-1" style="height: 22px; width: 22px;" class="import-pending__step-icon">$systemInstallations</v-icon>
            <div class="import-pending__step-info gray--text text--darken-1 mt-3 px-2">
              {{ $t('message.status.install.failed') }}
              <a class="error--text" @click="$emit('try-again-click')">
                {{ $t('button.try') }}
              </a>
            </div>
          </div>
          <v-progress-linear
            :value="100"
            color="red"
            class="import-pending__progress mb-1 mt-7"
            rounded
          />
        </template>
        <template v-else-if="status === 'success'">
          {{ $t('message.status.install.success') }}
        </template>
        <template v-else-if="imported">
          <v-icon size="16">$download</v-icon>
          <p class="pending-text">{{ $t('message.status.importing.inProgress') }}</p>
          <p class="pending-text">{{ $t('message.status.importing.wait') }}</p>
        </template>
        <template v-else>{{ $t('message.status.install.inProgress') }}</template>
      </div>
    </div>
  </div>
</template>

<script>
// import InstanceItemInstallationIllustrationError from "../illustrations/instance-item-installation-illustration-error.vue";
// import InstanceItemInstallationIllustrationPending from "../illustrations/instance-item-installation-illustration-pending.vue";
// import InstanceItemImporting from "../illustrations/instance-item-importing.vue";

// import Loader from "../Loader.vue";

export default {
  components: {
    // Loader,
    // InstanceItemInstallationIllustrationError,
    // InstanceItemInstallationIllustrationPending,
    // InstanceItemImporting,
  },
  props: {
    status: String,
    imported: Boolean,
  },
  computed: {
    isImport() {
      return this.instance.import_details !== null;
    },
    currentStep() {
      return this.instance?.import_details?.current_step ?? null;
    },
    stepPercent() {
      if (!this.currentStep) return null;
      const p = this.currentStep.percent;
      return typeof p === 'number' ? p : null;
    },
  },
};
</script>

<style lang="scss" scoped>
.installation-pending {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  position: relative;
  &::before {
    content: "";
    position: absolute;
    z-index: 1;
    // background: var(--v-primary-lighten4);
    opacity: 0.8;
    height: 100%;
    width: 100%;
  }

  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    z-index: 2;
  }

  &__background {
    z-index: 0;
    color: var(--v-primary-base);
  }
  &__img {
    position: absolute;
    top: calc(-2px);
    left: calc(50% - 40px);
    z-index: 2;
  }

  &__text {
    color: map-get($text, base);
    a {
      color: map-get($primary, darken1);
      transition: color 0.24s ease;
      &:hover {
        color: map-get($primary, base);
      }
    }
  }

  &--error {
    &::before {
      // background: var(--v-error-lighten5);
    }
    .installation-pending {
      &__background  svg * {
       fill: var(--v-error-lighten5);
       stroke: var(--v-error-lighten5)
      }
    }
  }
  .pending-text{
    font-size: 12px;
    line-height: 12px;
    color: map-get($gray, lighten1);
    text-align: center;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: -30px;
    width: 106px;
  }
  
}
</style>
<style lang="scss">
.pending-animation{
  [data-animation-pending]{
    transition: transform 0.3s;
    animation: pendingImport 1.5s infinite;
    overflow: hidden;
  }
}
@keyframes pendingImport {
    0% {
      transform: translateY(-15px);
    }
    100% {
      transform: translateY(15px);
    }
  }
</style>